export const login_success = (data) => ({ type: 'LOGIN_SUCCESS', data });
export const logout = () => ({ type: 'LOG_OUT' });
